module.exports = __webpack_public_path__ + "static/media/Workday_Step2d_Image9.f399357d.jpg";